import * as React from "react";
import { cn } from "@/lib/utils";

export type StatusTone = "success" | "cyan" | "danger";

const toneStyles: Record<StatusTone, string> = {
  success:
    "border-[#3DDC84]/40 bg-[#3DDC84]/10 text-[#3DDC84] [--dot:#3DDC84]",
  cyan: "border-[#2E7BFF]/40 bg-[#2E7BFF]/10 text-[#2E7BFF] [--dot:#2E7BFF]",
  danger: "border-[#FF5C6C]/40 bg-[#FF5C6C]/10 text-[#FF5C6C] [--dot:#FF5C6C]",
};

export interface StatusPillProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  tone: StatusTone;
  pulse?: boolean;
}

export const StatusPill = React.forwardRef<HTMLSpanElement, StatusPillProps>(
  ({ className, tone, pulse = false, children, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        "inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-wider",
        toneStyles[tone],
        className,
      )}
      {...props}
    >
      <span
        className={cn(
          "h-2 w-2 rounded-full bg-[var(--dot)]",
          pulse && "animate-pulse-glow",
        )}
        style={{ boxShadow: "0 0 8px var(--dot)" }}
      />
      {children}
    </span>
  ),
);
StatusPill.displayName = "StatusPill";
